import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {Store} from '@ngrx/store';

import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';

import {AppState} from '@store/app.states';


import {AdminSurveysListService} from '../admin-surveys-list.service';
import {AdminSurveysActionTypes, DisplayPartialsForSurvey, DisplayPartialsForSurveySuccess} from '../store/surveys-list.actions';

@Injectable()
export class SurveysListEffect {
  constructor(
    private actions: Actions,
    private store: Store<AppState>,
    private surveysListService: AdminSurveysListService,
  ) {
  }

  //
  // Deprecrated ?
  //
  // refreshList = createEffect(() => this.actions.pipe(
  //   ofType(AdminSurveysActionTypes.RefreshList),
  //   switchMap(payload => {
  //     console.log('----------------------- AdminSurveysActionTypes.RefreshList');
  //     return this.surveysListService.getSurveysList()
  //       .pipe(
  //         map(data => new RefreshListSuccess({surveyList: data.data.surveysList, secretToken: data.data.secretToken})),
  //         catchError(error =>
  //           of(new RefreshListFailure({error}))
  //         )
  //       );
  //   }),
  // ));

  // DisplayPartialsForSurvey = createEffect(() => this.actions.pipe(
  //   ofType(AdminSurveysActionTypes.DisplayPartialsForSurvey),
  //   map((action: DisplayPartialsForSurvey) => action.payload),
  //   switchMap(payload => {
  //     return this.surveysListService.getPartialOnlyForSurveyId(payload.surveyId)
  //       .pipe(
  //         map(data => {
  //           // console.log(data.data.datas);
  //           return new DisplayPartialsForSurveySuccess({datas: data.data.datas});
  //         }),
  //         catchError(error =>
  //           of(new RefreshListFailure({error}))
  //         )
  //       );
  //   }),
  // ));


}
